import React from 'react';
import { CupSodaIcon, Utensils, HeartIcon, DropletIcon } from 'lucide-react';
const RestaurantFunctionalShots = () => {
  return <section className="py-20 bg-gradient-to-br from-blue-50 via-white to-blue-50" data-id="element-1080">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1081">
        <div className="text-center mb-16" data-id="element-1082">
          <span className="inline-flex items-center px-4 py-1.5 rounded-full text-sm font-medium bg-blue-500 text-white shadow-sm mb-4" data-id="element-1083">
            EXCLUSIVE RESTAURANT OFFERINGS
          </span>
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-1084">
            Craft Beverage Solutions for Restaurants
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1085">
            Elevate your beverage menu with premium options that complement your
            culinary offerings
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1086">
          {/* Signature Mocktails */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all hover:transform hover:scale-105" data-id="element-1087">
            <div className="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mb-6 mx-auto" data-id="element-1088">
              <CupSodaIcon className="h-8 w-8 text-purple-500" data-id="element-1089" />
            </div>
            <h3 className="text-xl font-semibold text-center text-navy-950 mb-4" data-id="element-1090">
              Signature Mocktails
            </h3>
            <p className="text-gray-600 text-center" data-id="element-1091">
              Create house-exclusive non-alcoholic craft beverages that
              complement your menu and enhance the dining experience.
            </p>
            <div className="mt-6 text-center" data-id="element-1092">
              <span className="inline-block px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-sm font-medium" data-id="element-1093">
                🍹 Premium upsell opportunity
              </span>
            </div>
          </div>
          {/* Menu Pairings */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all hover:transform hover:scale-105" data-id="element-1094">
            <div className="bg-amber-100 rounded-full w-16 h-16 flex items-center justify-center mb-6 mx-auto" data-id="element-1095">
              <Utensils className="h-8 w-8 text-amber-500" data-id="element-1096" />
            </div>
            <h3 className="text-xl font-semibold text-center text-navy-950 mb-4" data-id="element-1097">
              Menu Pairings
            </h3>
            <p className="text-gray-600 text-center" data-id="element-1098">
              Offer curated beverage pairings that enhance specific dishes,
              creating a complete flavor experience for your guests.
            </p>
            <div className="mt-6 text-center" data-id="element-1099">
              <span className="inline-block px-3 py-1 bg-amber-50 text-amber-700 rounded-full text-sm font-medium" data-id="element-1100">
                🍽️ Culinary enhancement
              </span>
            </div>
          </div>
          {/* Health-Conscious Options */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all hover:transform hover:scale-105" data-id="element-1101">
            <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mb-6 mx-auto" data-id="element-1102">
              <HeartIcon className="h-8 w-8 text-green-500" data-id="element-1103" />
            </div>
            <h3 className="text-xl font-semibold text-center text-navy-950 mb-4" data-id="element-1104">
              Health-Conscious Options
            </h3>
            <p className="text-gray-600 text-center" data-id="element-1105">
              Meet growing demand for clean-label beverages with no artificial
              ingredients, appealing to health-focused diners.
            </p>
            <div className="mt-6 text-center" data-id="element-1106">
              <span className="inline-block px-3 py-1 bg-green-50 text-green-700 rounded-full text-sm font-medium" data-id="element-1107">
                🌱 Clean-label appeal
              </span>
            </div>
          </div>
          {/* Premium Waters */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all hover:transform hover:scale-105" data-id="element-1108">
            <div className="bg-cyan-100 rounded-full w-16 h-16 flex items-center justify-center mb-6 mx-auto" data-id="element-1109">
              <DropletIcon className="h-8 w-8 text-cyan-500" data-id="element-1110" />
            </div>
            <h3 className="text-xl font-semibold text-center text-navy-950 mb-4" data-id="element-1111">
              Premium Waters
            </h3>
            <p className="text-gray-600 text-center" data-id="element-1112">
              Offer alkaline and specialty waters that enhance the dining
              experience while providing higher margins than bottled options.
            </p>
            <div className="mt-6 text-center" data-id="element-1113">
              <span className="inline-block px-3 py-1 bg-cyan-50 text-cyan-700 rounded-full text-sm font-medium" data-id="element-1114">
                💧 High-margin essentials
              </span>
            </div>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-1115">
          <a href="#book-demo" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-lg shadow-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all" data-id="element-1116">
            Schedule Your Restaurant Demo
          </a>
        </div>
      </div>
    </section>;
};
export default RestaurantFunctionalShots;